import mergeDeep from '@/utils/merge-deep';
import { SectionOneColumnThemeControls } from '@/components/organisms/SectionOneColumn/theming';

import block from './block.json';

export const sectionSubscriptionThemeAttributes = {
	backgroundColor: '@tokens.colors.brand-quaternary-base.value',
	padding: {
		// without control (for Storybook only)
		top: [60, 83],
		bottom: [62, 104],
	},
	title: {
		color: '@tokens.variants.default.titleColor',
		typography: '@tokens.typographies.heading-2',
		textAlignment: 'left',
	},
	info: {
		color: '@tokens.variants.default.titleColor',
		typography: '@tokens.typographies.text-s-bold',
		textAlignment: 'left',
	},
};

export const SectionSubscriptionThemeControls: ThemeControlsType = mergeDeep(
	SectionOneColumnThemeControls,
	{
		// What's displayed
		title: block.title,

		// Unique string/id of the block (= the key used in theme.json)
		slug: block.slug,

		// styling attributes available for this block
		// ...the same way we define attributes for a gutenberg block
		attributes: sectionSubscriptionThemeAttributes,
	}
);
